import styled from 'styled-components';

import { AdornedInput, Input } from '@zillow/constellation';

export const StyledAdornedInput = styled(AdornedInput)`
    & ${Input} {
        border: none;
        padding-left: 16px;
    }
    border-radius: 4px;
    border: 1px solid #D1D1D5;
    :active,:focus,:hover {
        border-color: #006AFF;
    }
    &label{
        border: none;
    }
    label[class^="StyledAdornment"]{
        border: none;
    }
`;
